import React from 'react';
import { stringToData } from '../../../../core/util';
import GridInput from '../../../../components/form/GridInput';
import { isValidCPF } from '../../../../core/validations/index';

function GeneralInfo(props) {
  const { org, view, combos, fetchStudentByCpf } = props;

  return (
    <>
      <GridInput name="nome" label="Nome completo" lg={8} required />
      <GridInput name="apelido" label="Apelido" lg={4} required />

      <GridInput name="email" label="E-mail" disabled lg={8} required />

      <GridInput
        name="dataNascimento"
        label="Data de Nascimento"
        type="date"
        lg={4}
        required
      />

      <GridInput
        name="cpf"
        label="CPF"
        type="cpf"
        md={6}
        lg={4}
        required
        onChange={(event) => {
          const currentCpf = stringToData('cpf', event.target.value);
          if (isValidCPF(currentCpf)) {
            fetchStudentByCpf(currentCpf, view, org);
          }
        }}
      />
      <GridInput name="rg" label="RG" md={6} lg={4} />

      <GridInput
        name="sexo"
        label="Sexo"
        type="select"
        options={combos.gender}
        md={6}
        lg={4}
        required
      />
    </>
  );
}

export default GeneralInfo;
